import { formatDate } from '@angular/common';
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { da, el } from 'date-fns/locale';
import { ComponentsService } from 'src/app/components.service';
import { Statistics } from './model/statistic';
import { MatMenu } from '@angular/material/menu';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { trigger } from '@angular/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
    selector: 'app-filter-bar',
    templateUrl: './filter-bar.component.html',
    styleUrls: ['./filter-bar.component.css']
})
export class FilterBarComponent implements OnInit, OnDestroy {
    @Input() filterComponentName: any;
    @ViewChild('inputStartDate') startRef: ElementRef;
    @ViewChild('inputEndDate') endRef: ElementRef;
    @ViewChild('dateSlot') dateSlot: MatMenu;
    ticketCode: string;
    pinCode: string = null;
    deviceChosen: string = 'all';
    users: Array<object> = [];
    locations: Array<object> = [];
    kiosks: Array<object> = [];
    clientUuid;
    params;
    usersArr: Array<number> = [];
    filterForm: FormGroup;
    filterFormSlots: FormGroup;
    selectedUsersArr: [number];
    defaultDate;
    filteredTikets: any;
    filteredEvents: any;
    startNumber: number = 0;
    numberOfRows: number = 100;
    clientChangeSub;
    paginationTiksChangeSub;
    paginationEvsChangeSub;
    paginationSlotChangeSub;
    activeRouteSub;
    gameCode;
    refeshPageSub;
    sub: any;
    savedDateStart;
    savedDateEnd;
    savedDateStartSlots;
    savedDateEndSlots;
    numOfShopsSelected = 0;
    timeZone;
    shop_id: number;
    selectedLocation: any;

    isModalVisible = false;

    isDisabled = true;
    modalShopOpen = false;
    emitPOSdevice = false;

    offset: any;
    kotLimit = '';
    created = '';
    pagingDirection = 'f';

    itemsPerPage: number = 100;
    @Output() ticketCodeSearchEvent = new EventEmitter();

    predefinedDateOptions = [
        { value: 'aktualni-datum', viewValue: 'Current date' },
        { value: 'prethodni-dan', viewValue: 'Previous day' },
        { value: 'trenutna-sedmica', viewValue: 'Current week' },
        { value: 'prethodna-sedmica', viewValue: 'Previous week' },
        { value: 'trenutni-mesec', viewValue: 'Current month' },
        { value: 'prethodni-mesec', viewValue: 'Previous month' }
    ];

    tStatuses = [
        { val: 'open', viewValue: 'Open', selected: false },
        { val: 'temp', viewValue: 'Temp', selected: false },
        { val: 'resolved', viewValue: 'Resolved', selected: false }
    ];

    tStatusesSlot = [
        { val: 'open', viewValue: 'Open', selected: false },
        // { val: 'won', viewValue: 'Won', selected: false },
        { val: 'lost', viewValue: 'Lost', selected: false },
        { val: 'redeemed', viewValue: 'Redeemed', selected: false }
        // { val: 'canceled', viewValue: 'Canceled', selected: false },
    ];
    filteredSlotObservable: any[];
    numberOfFilteredSlot: any;
    iframeUrl: SafeResourceUrl = '';
    currentData: any;
    voidTriger: boolean = false;
    ticketForVoid: any;
    gameType: string;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private service: ComponentsService,
        private activeRoute: ActivatedRoute,
        private route: Router,
        private fb: FormBuilder,
        elm: ElementRef,
        private dateAdapter: DateAdapter<Date>,
        private sanitizer: DomSanitizer
    ) {
        this.filterComponentName = elm.nativeElement.getAttribute(
            'filterComponentName'
        );

        this.service.filteredTikets.subscribe(
            (filteredTiks) => (this.filteredTikets = filteredTiks)
        );
        this.service.filteredEvents.subscribe(
            (filteredEvs) => (this.filteredEvents = filteredEvs)
        );
        this.service.filteredSlotObservable.subscribe(
            (filteredSlt) => (this.filteredSlotObservable = filteredSlt)
        );
        this.dateAdapter.setLocale('en-GB');
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');
    }

    ngOnInit(): void {
        this.service.timeZoneChanged.subscribe(() => {
            this.resetFilters();
            this.resetFiltersSlots();
        });

        this.service.iframeEmiter.subscribe((data) => {
            this.currentData = data; // Čuvaj trenutne podatke da bi ih ponovo koristio
        });

        this.defaultDate = new Date();
        this.filterForm = this.fb.group({
            start_date: this.fb.control(this.defaultDate),
            end_date: this.fb.control(this.defaultDate),
            predefined_date: this.fb.control(''),
            start_date_send: this.fb.control(''),
            end_date_send: this.fb.control(''),
            wagering_device: this.fb.control(this.service.getDeviceType()),
            user_ids: this.fb.array([]),
            shop_ids: this.fb.array([]),
            ticket_status: this.fb.array([]),
            userUuid: this.fb.control(''),
            terminal_id: this.fb.control(''),
            kiosk_ids: this.fb.array([]),
            ticket_code: this.fb.control(''),
            user_uuid: this.fb.control('')
        });

        this.filterFormSlots = this.fb.group({
            start_date: this.fb.control(this.defaultDate),
            end_date: this.fb.control(this.defaultDate),
            start_date_send: this.fb.control(''),
            end_date_send: this.fb.control(''),
            userId: this.fb.control(''),
            sessionId: this.fb.control(''),
            gameplay_slot_status: this.fb.array([])
        });

        this.refeshPageSub = this.service.refreshPage.subscribe(() => {
            this.search();
        });

        this.activeRoute.url.subscribe((url) => {
            this.service.setDeviceType('all');
            this.deviceChosen = this.service.getDeviceType();
            this.service.setClientUuid(this.service.getUsersPerm().clientUuid);
            this.gameCode = url[1].path;
            this.clientUuid = this.service.getClientUuid();

            this.filterForm = this.fb.group({
                start_date: this.fb.control(this.defaultDate),
                end_date: this.fb.control(this.defaultDate),
                predefined_date: this.fb.control(''),
                start_date_send: this.fb.control(''),
                end_date_send: this.fb.control(''),
                wagering_device: this.fb.control(this.service.getDeviceType()),
                user_ids: this.fb.array([]),
                shop_ids: this.fb.array([]),
                ticket_status: this.fb.array([]),
                userUuid: this.fb.control(''),
                terminal_id: this.fb.control(''),
                kiosk_ids: this.fb.array([]),
                ticket_code: this.fb.control(''),
                user_uuid: this.fb.control('')
                // userIdSlot: this.fb.control(''),
                // sessionId: this.fb.control(''),
                // gameplay_slot_status: this.fb.array([])
            });

            this.filterFormSlots = this.fb.group({
                start_date: this.fb.control(this.defaultDate),
                end_date: this.fb.control(this.defaultDate),
                start_date_send: this.fb.control(''),
                end_date_send: this.fb.control(''),
                userIdSlot: this.fb.control(''),
                sessionId: this.fb.control(''),
                gameplay_slot_status: this.fb.array([])
            });

            this.tStatuses = [
                { val: 'open', viewValue: 'Open', selected: false },
                { val: 'temp', viewValue: 'Temp', selected: false },
                { val: 'resolved', viewValue: 'Resolved', selected: false }
            ];

            this.tStatusesSlot = [
                { val: 'open', viewValue: 'Open', selected: false },
                // { val: 'won', viewValue: 'Won', selected: false },
                { val: 'lost', viewValue: 'Lost', selected: false },
                { val: 'redeemed', viewValue: 'Redeemed', selected: false }
                // { val: 'canceled', viewValue: 'Canceled', selected: false },
            ];

            this.filterFormSlots = this.fb.group({
                start_date: this.fb.control(this.defaultDate),
                end_date: this.fb.control(this.defaultDate),
                start_date_send: this.fb.control(''),
                end_date_send: this.fb.control(''),
                userIdSlot: this.fb.control(''),
                sessionId: this.fb.control(''),
                gameplay_slot_status: this.fb.array([])
            });
            this.search();
        });

        this.activeRouteSub = this.activeRoute.params.subscribe((params) => {
            this.params = params;
            const currentGameCode = this.params.gameCode;
            if (this.gameCode !== currentGameCode) {
                this.startNumber = 0;
            }
            this.gameCode = currentGameCode;
        });

        if (this.service.getUsersPerm().superAdmin == 1) {
            this.clientChangeSub = this.service.clientChanged.subscribe(
                async (newId) => {
                    this.service.setClientUuid(newId.clientUuid);
                    const data = await this.service.getUsers(this.clientUuid);
                    this.users = data;
                }
            );
        }

        if (this.filterComponentName == 'tickets') {
            this.paginationTiksChangeSub =
                this.service.paginationChanges.subscribe((data) => {
                    this.startNumber = data.start_number;
                    this.numberOfRows = data.number_of_rows;
                    this.clientUuid = data.clientUuid;
                    this.onSubmit(true, data.page_filters);
                });
        } else if (this.filterComponentName == 'events') {
            this.paginationEvsChangeSub =
                this.service.paginationChanges.subscribe((data) => {
                    this.kotLimit = data[0];
                    this.numberOfRows = data[1];
                    this.clientUuid = data[2];
                    this.pagingDirection = data[3];

                    this.onSubmit(true, {});
                });
        }
    }

    myDateFormater(date) {
        let myDateArray = date.split(' ')[0].split('/');
        let myTime = date.split(' ')[1];
        return (
            myDateArray[2] +
            '-' +
            myDateArray[1] +
            '-' +
            myDateArray[0] +
            ' ' +
            myTime
        );
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }

        if (this.activeRouteSub) {
            this.activeRouteSub.unsubscribe();
        }

        if (this.clientChangeSub) {
            this.clientChangeSub.unsubscribe();
        }

        if (this.paginationTiksChangeSub) {
            this.paginationTiksChangeSub.unsubscribe();
        }

        if (this.paginationEvsChangeSub) {
            this.paginationEvsChangeSub.unsubscribe();
        }

        if (this.paginationSlotChangeSub) {
            this.paginationSlotChangeSub.unsubscribe();
        }

        if (this.refeshPageSub) {
            this.refeshPageSub.unsubscribe();
        }

        this.service.setDeviceType(null);
    }

    setSelectedLocation(location: any) {
        this.shop_id = location.shop_id;
        let { shop_name, location_id, selected } = location;
        let locationObject = { shop_name, location_id, selected };

        // Emituj novu selektovanu lokaciju
        this.service.selectedLocation.emit(locationObject);
    }

    setSelectedUser(user) {
        this.service.selectedUser.emit(user);
    }

    onUserChecked(id: string): void {
        const userFormArray = <FormArray>this.filterForm.controls.user_ids;

        // Pronađi indeks trenutno selektovanog korisnika, ako postoji
        const currentIndex = this.users.findIndex(
            (user) => user['user_id'] === id
        );

        // Ako je trenutni korisnik već selektovan, poništi njegovu selekciju
        if (currentIndex !== -1 && this.users[currentIndex]['selected']) {
            this.users[currentIndex]['selected'] = false;
            const indexInForm = userFormArray.controls.findIndex(
                (x) => x.value === id
            );
            if (indexInForm !== -1) {
                userFormArray.removeAt(indexInForm);
            }
        } else {
            // Deselektuj prethodno selektovanog korisnika ako postoji
            const prevSelectedIndex = this.users.findIndex(
                (user) => user['selected']
            );
            if (prevSelectedIndex !== -1) {
                this.users[prevSelectedIndex]['selected'] = false;
                const prevSelectedId = this.users[prevSelectedIndex]['user_id'];
                const prevSelectedIndexInForm =
                    userFormArray.controls.findIndex(
                        (x) => x.value === prevSelectedId
                    );
                if (prevSelectedIndexInForm !== -1) {
                    userFormArray.removeAt(prevSelectedIndexInForm);
                }
            }

            // Selektuj trenutnog korisnika
            if (currentIndex !== -1) {
                this.users[currentIndex]['selected'] = true;

                userFormArray.push(new FormControl(id));
                // Pozovi onShopChecked metodu
                this.onShopChecked(this.users[currentIndex]['shop_id'], true);
            }
        }

        // Deselektuj sve korisnike koji nisu trenutno selektovani
        this.users
            .filter((user) => user['user_id'] !== id)
            .forEach((user) => {
                if (user['selected']) {
                    user['selected'] = false;
                    const indexInForm = userFormArray.controls.findIndex(
                        (x) => x.value === user['user_id']
                    );
                    if (indexInForm !== -1) {
                        userFormArray.removeAt(indexInForm);
                    }
                }
            });
    }

    onPaste(data: any) {
        data.target.value = data.target.value.trim();
    }

    onShopChecked(id: string, elementFromShopSelected: boolean): void {
        const shopFormArray = <FormArray>this.filterForm.controls.shop_ids;
        const userFormArray = <FormArray>this.filterForm.controls.user_ids;
        const kioskFormArray = <FormArray>this.filterForm.controls.kiosk_ids;
        let clearAll = false;
        let checkedLocationID: any;
        // Reset location selectioelementFromShopSelectedn if a shop is selected and a location is already selected

        if (!elementFromShopSelected && this.numOfShopsSelected > 0) {
            this.locations.forEach((location: any) => {
                if (location.selected) {
                    location.selected = false;
                    checkedLocationID = location.shop_id;
                }
            });
            // // Clear form arrays
            shopFormArray.clear();
            userFormArray.clear();
            kioskFormArray.clear();
            // Reset counters
            this.numOfShopsSelected = 0;
            // Update user and kiosk visibility if needed
            if (this.deviceChosen === 'shop') {
                this.users.forEach((user) => (user['hide'] = false));
            } else if (this.deviceChosen === 'SSBT') {
                this.kiosks.forEach((kiosk) => (kiosk['hide'] = false));
            }
        }

        if (checkedLocationID == id) clearAll = true;

        if (clearAll) {
            this.filterForm.get('shop_ids').setValue([]);
        } else {
            for (let i = 0; i < this.locations.length; i++) {
                if (this.locations[i]['shop_id'] == id) {
                    if (
                        !elementFromShopSelected &&
                        this.locations[i]['selected'] == true
                    ) {
                        this.numOfShopsSelected = -1;
                        this.locations[i]['selected'] = false;
                        let index = shopFormArray.controls.findIndex(
                            (x) => x.value == this.locations[i]['shop_id']
                        );
                        shopFormArray.removeAt(index);
                        this.numOfShopsSelected--;
                        if (this.deviceChosen == 'shop') {
                            this.users.forEach((user) => {
                                if (user['shop_id'] == id && user['selected']) {
                                    let uindex =
                                        userFormArray.controls.findIndex(
                                            (x) => x.value == user['user_id']
                                        );
                                    userFormArray.removeAt(uindex);
                                }
                                user['hide'] =
                                    user['shop_id'] == id ? true : user['hide'];
                                user['selected'] =
                                    user['shop_id'] == id
                                        ? false
                                        : user['selected'];
                            });
                        } else if (this.deviceChosen == 'SSBT') {
                            this.kiosks.forEach((kiosk) => {
                                if (
                                    kiosk['shop_id'] == id &&
                                    kiosk['selected']
                                ) {
                                    let kindex =
                                        kioskFormArray.controls.findIndex(
                                            (x) =>
                                                x.value == kiosk['terminal_id']
                                        );
                                    kioskFormArray.removeAt(kindex);
                                }
                                kiosk['hide'] =
                                    kiosk['shop_id'] == id
                                        ? true
                                        : kiosk['hide'];
                                kiosk['selected'] =
                                    kiosk['shop_id'] == id
                                        ? false
                                        : kiosk['selected'];
                            });
                        }
                        if (this.numOfShopsSelected == 0) {
                            this.uncheckAll('location');
                        }
                    } else {
                        this.locations[i]['selected'] = true;

                        let index = shopFormArray.controls.findIndex(
                            (x) => x.value == id
                        );

                        if (index === -1) {
                            shopFormArray.push(
                                new FormControl(this.locations[i]['shop_id'])
                            );
                            this.numOfShopsSelected++;
                        }

                        if (this.deviceChosen == 'shop') {
                            this.users.forEach((user) => {
                                user['hide'] =
                                    user['shop_id'] == id
                                        ? false
                                        : this.numOfShopsSelected == 1
                                          ? true
                                          : user['hide'];
                            });
                        } else if (this.deviceChosen == 'SSBT') {
                            this.kiosks.forEach((kiosk) => {
                                kiosk['hide'] =
                                    kiosk['shop_id'] == id
                                        ? false
                                        : this.numOfShopsSelected == 1
                                          ? true
                                          : kiosk['hide'];
                            });
                        }
                    }
                    break;
                }
            }
        }
    }

    onKioskChecked(id: string): void {
        const kioskFormArray = <FormArray>this.filterForm.controls.kiosk_ids;

        for (let i = 0; i < this.kiosks.length; i++) {
            if (this.kiosks[i]['terminal_id'] == id) {
                if (this.kiosks[i]['selected'] == true) {
                    this.kiosks[i]['selected'] = false;
                    let index = kioskFormArray.controls.findIndex(
                        (x) => x.value == this.kiosks[i]['terminal_id']
                    );
                    kioskFormArray.removeAt(index);
                } else {
                    this.onShopChecked(this.kiosks[i]['shop_id'], true);
                    this.kiosks[i]['selected'] = true;
                    kioskFormArray.push(
                        new FormControl(this.kiosks[i]['terminal_id'])
                    );
                }
            }
        }
    }

    onStatusChecked(status: string, isChecked: boolean): void {
        const statusFormArray = <FormArray>(
            this.filterForm.controls.ticket_status
        );
        for (let i = 0; i < this.tStatuses.length; i++) {
            if (this.tStatuses[i].val == status) {
                if (this.tStatuses[i].selected == true) {
                    this.tStatuses[i].selected = false;
                    let index = statusFormArray.controls.findIndex(
                        (x) => x.value == this.tStatuses[i].val
                    );
                    statusFormArray.removeAt(index);
                } else {
                    this.tStatuses[i].selected = true;
                    statusFormArray.push(
                        new FormControl(this.tStatuses[i].val)
                    );
                }
            }
        }
    }

    onStatusCheckedSlot(statusSlot: string, isChecked: boolean): void {
        const statusFormArray = <FormArray>(
            this.filterFormSlots.controls.gameplay_slot_status
        );
        for (let i = 0; i < this.tStatusesSlot.length; i++) {
            if (this.tStatusesSlot[i].val == statusSlot) {
                if (this.tStatusesSlot[i].selected == true) {
                    this.tStatusesSlot[i].selected = false;
                    let index = statusFormArray.controls.findIndex(
                        (x) => x.value == this.tStatusesSlot[i].val
                    );
                    statusFormArray.removeAt(index);
                } else {
                    this.tStatusesSlot[i].selected = true;
                    statusFormArray.push(
                        new FormControl(this.tStatusesSlot[i].val)
                    );
                }
            }
        }
    }

    compareUsers(a, b) {
        if (a.user === b.user) return 0;

        return a.user < b.user ? -1 : 1;
    }
    compareTerminals(a, b) {
        if (a.terminal === b.terminal) return 0;

        return a.terminal < b.terminal ? -1 : 1;
    }

    compareLocations(a, b) {
        if (a.shop_name === b.shoshop_namep) return 0;

        return a.shop_name < b.shop_name ? -1 : 1;
    }

    onPredefinedChange(event) {
        if (event.value == 'aktualni-datum') {
            this.filterForm.get('start_date').setValue(this.defaultDate);
            this.filterForm.get('end_date').setValue(this.defaultDate);
        } else if (event.value == 'prethodni-dan') {
            const yesterday = new Date(this.defaultDate);
            yesterday.setDate(yesterday.getDate() - 1);

            this.filterForm.get('start_date').setValue(yesterday);
            this.filterForm.get('end_date').setValue(yesterday);
        } else if (event.value == 'trenutni-mesec') {
            const firstDay = new Date(
                this.defaultDate.getFullYear(),
                this.defaultDate.getMonth(),
                1
            );
            const lastDay = new Date();

            this.filterForm.get('start_date').setValue(firstDay);
            this.filterForm.get('end_date').setValue(lastDay);
        } else if (event.value == 'prethodni-mesec') {
            const firstDay = new Date(
                this.defaultDate.getFullYear(),
                this.defaultDate.getMonth() - 1,
                1
            );
            const lastDay = new Date(
                this.defaultDate.getFullYear(),
                this.defaultDate.getMonth() - 1 + 1,
                0
            );

            this.filterForm.get('start_date').setValue(firstDay);
            this.filterForm.get('end_date').setValue(lastDay);
        } else if (event.value == 'trenutna-sedmica') {
            const weekstart =
                this.defaultDate.getDate() - this.defaultDate.getDay() + 1;
            const weekend = weekstart + 6; // end day is the first day + 6
            const currDate = new Date();
            const monday = new Date(currDate.setDate(weekstart));
            let sunday: Date;

            if (weekstart < 0) {
                sunday = new Date(
                    currDate.getFullYear(),
                    this.defaultDate.getMonth() - 1 + 1,
                    weekend
                );
            } else {
                sunday = new Date(currDate.setDate(weekend));
            }

            this.filterForm.get('start_date').setValue(monday);
            this.filterForm.get('end_date').setValue(sunday);
        } else if (event.value == 'prethodna-sedmica') {
            const currDate = new Date();
            const weekAgo = new Date(
                currDate.setDate(
                    this.defaultDate.getDate() - this.defaultDate.getDay() + 1
                )
            );
            const lastMonday = new Date(
                weekAgo.getFullYear(),
                weekAgo.getMonth(),
                weekAgo.getDate() - 7
            );
            const lastSunday = new Date(
                lastMonday.getFullYear(),
                lastMonday.getMonth(),
                lastMonday.getDate() + 6
            );

            this.filterForm.get('start_date').setValue(lastMonday);
            this.filterForm.get('end_date').setValue(lastSunday);
        }
    }

    selectAll(type: string) {
        if (type == 'status') {
            const statusFormArray = <FormArray>(
                this.filterForm.controls.ticket_status
            );
            this.tStatuses.forEach((status) => {
                if (!status.selected) {
                    statusFormArray.push(new FormControl(status.val));
                }
                status.selected = true;
            });
        } else if (type == 'statusSlot') {
            const statusFormArray = <FormArray>(
                this.filterFormSlots.controls.gameplay_slot_status
            );
            this.tStatusesSlot.forEach((statusSlot) => {
                if (!statusSlot.selected) {
                    statusFormArray.push(new FormControl(statusSlot.val));
                }
                statusSlot.selected = true;
            });
        } else if (type == 'users') {
            const userFormArray = <FormArray>this.filterForm.controls.user_ids;
            this.users.forEach((user) => {
                if (!user['selected']) {
                    userFormArray.push(new FormControl(user['user_id']));
                }
                user['selected'] = true;
                this.onShopChecked(user['shop_id'], true);
            });
        } else if (type == 'location') {
            this.numOfShopsSelected = this.locations.length;

            const shopFormArray = <FormArray>this.filterForm.controls.shop_ids;
            this.locations.forEach((shop) => {
                if (!shop['selected']) {
                    shopFormArray.push(new FormControl(shop['shop_id']));
                }
                shop['selected'] = true;
            });

            if (this.deviceChosen == 'shop') {
                this.users.forEach((user) => {
                    user['hide'] = false;
                });
            } else if (this.deviceChosen == 'SSBT') {
                this.kiosks.forEach((kiosk) => {
                    kiosk['hide'] = false;
                });
            }
        } else if (type == 'terminal') {
            const kioskFormArray = <FormArray>(
                this.filterForm.controls.kiosk_ids
            );
            this.kiosks.forEach((kiosk) => {
                if (!kiosk['selected']) {
                    kioskFormArray.push(new FormControl(kiosk['terminal_id']));
                }
                kiosk['selected'] = true;
                this.onShopChecked(kiosk['shop_id'], true);
            });
        }
    }
    uncheckAll(type: string) {
        if (type == 'status') {
            const statusFormArray = <FormArray>(
                this.filterForm.controls.ticket_status
            );
            this.tStatuses.forEach((status) => {
                status.selected = false;
            });
            statusFormArray.clear();
        } else if (type == 'statusSlot') {
            const statusFormArray = <FormArray>(
                this.filterFormSlots.controls.gameplay_slot_status
            );
            this.tStatusesSlot.forEach((statusSlot) => {
                statusSlot.selected = false;
            });
            statusFormArray.clear();
        } else if (type == 'users') {
            const userFormArray = <FormArray>this.filterForm.controls.user_ids;
            this.users.forEach((user) => {
                user['selected'] = false;
            });
            userFormArray.clear();
        } else if (type == 'location') {
            this.numOfShopsSelected = 0;
            const shopFormArray = <FormArray>this.filterForm.controls.shop_ids;
            this.locations.forEach((shop) => {
                shop['selected'] = false;
            });
            shopFormArray.clear();
            if (this.deviceChosen == 'shop') {
                this.users.forEach((user) => {
                    user['hide'] = false;
                    user['selected'] = false;
                });
                const userFormArray = <FormArray>(
                    this.filterForm.controls.user_ids
                );
                userFormArray.clear();
            } else if (this.deviceChosen == 'SSBT') {
                this.kiosks.forEach((kiosk) => {
                    kiosk['hide'] = false;
                    kiosk['selected'] = false;
                });
                const kioskFormArray = <FormArray>(
                    this.filterForm.controls.kiosk_ids
                );
                kioskFormArray.clear();
            }
        } else if (type == 'terminal') {
            const kioskFormArray = <FormArray>(
                this.filterForm.controls.kiosk_ids
            );
            this.kiosks.forEach((kiosk) => {
                kiosk['selected'] = false;
            });
            kioskFormArray.clear();
        }
    }

    resetFilters() {
        this.filterForm = this.fb.group({
            start_date: this.fb.control(new Date()),
            end_date: this.fb.control(new Date()),
            predefined_date: this.fb.control(''),
            start_date_send: this.fb.control(''),
            end_date_send: this.fb.control(''),
            wagering_device: this.fb.control('all'),
            user_ids: this.fb.array([]),
            shop_ids: this.fb.array([]),
            ticket_status: this.fb.array([]),
            userUuid: this.fb.control(''),
            terminal_id: this.fb.control(''),
            kiosk_ids: this.fb.array([]),
            ticket_code: this.fb.control(''),
            user_uuid: this.fb.control(''),
            userIdSlot: this.fb.control(''),
            sessionId: this.fb.control(''),
            gameplay_slot_status: this.fb.array([])
        });
        this.ticketCode = '';
        this.locations.forEach((shop) => {
            shop['selected'] = false;
        });
        this.isDisabled = true;
        this.voidTriger = false;

        this.users.forEach((user) => {
            user['selected'] = false;
        });

        this.tStatuses.forEach((status) => {
            status.selected = false;
        });

        this.tStatusesSlot.forEach((statusSlot) => {
            statusSlot.selected = false;
        });

        this.service.setDeviceType('all');
        this.deviceChosen = this.service.getDeviceType();

        this.service.selectedLocation.emit('');
        this.service.selectedUser.emit('');
        this.service.selectedUserUuid.emit('');
        this.search();
    }

    resetFiltersSlots() {
        this.filterFormSlots = this.fb.group({
            start_date: this.fb.control(new Date()),
            end_date: this.fb.control(new Date()),
            start_date_send: this.fb.control(''),
            end_date_send: this.fb.control(''),
            userIdSlot: this.fb.control(''),
            sessionId: this.fb.control(''),
            gameplay_slot_status: this.fb.array([])
        });

        this.tStatusesSlot.forEach((statusSlot) => {
            statusSlot.selected = false;
        });

        this.search();
    }

    saveCurrentDate() {
        //return old datess
        this.savedDateStart = this.filterForm.get('start_date').value;
        this.savedDateEnd = this.filterForm.get('end_date').value;
    }
    saveCurrentDateSlots() {
        //return old datess
        this.savedDateStartSlots = this.filterFormSlots.get('start_date').value;
        this.savedDateEndSlots = this.filterFormSlots.get('end_date').value;
    }
    onDateSelected() {
        //this.onSubmit();
    }
    onDateFilterCancel() {
        this.filterForm.get('start_date').setValue(this.savedDateStart);
        this.filterForm.get('end_date').setValue(this.savedDateEnd);
    }

    onDateFilterCancelSlots() {
        this.filterFormSlots
            .get('start_date')
            .setValue(this.savedDateStartSlots);
        this.filterFormSlots.get('end_date').setValue(this.savedDateEndSlots);
    }

    showIframe(): void {
        // Koristi prethodno emitovane podatke i kreiraj URL svaki put kad otvoriš modal
        if (this.currentData) {
            const url = `https://gamestest1.exevirtual.com/${this.currentData.gameCode}/index.php?deviceType=desktop&userUuid=${this.currentData.userUuid}&sessionUuid=${this.currentData.sessionUuid}&language=en&clientName=c2629cff41143af94bcec66d52117d75c370fb22&ccy=${this.currentData.tm_ccy}&bo=true&balance=${this.currentData.cpp_credits_start}&rid=${this.currentData.rid}&bet=${this.currentData.tm_payin}&newBalance=${this.currentData.cpp_credits_end}`;

            // Sanitizuj URL pre nego što ga postaviš u iframe
            this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }

        // Prikaži modal
        this.isModalVisible = true;
        this.service.openSideBar.emit(this.isModalVisible);
    }

    closeModal(): void {
        this.isModalVisible = false;
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');
        this.service.openSideBar.emit(this.isModalVisible);
    }

    loadTickets() {
        const start = this.getStartDate();
        const end = this.getEndDate();

        this.filterForm.get('start_date_send').setValue(start);
        this.filterForm.get('end_date_send').setValue(end);

        let filterStatus = [];

        for (let i = 0; i < this.tStatuses.length; i++) {
            if (this.tStatuses[i].selected == true) {
                filterStatus.push(this.tStatuses[i].val);
            }
        }

        const filterData: any = {
            ...(start && { dateFrom: start }),
            ...(end && { dateTo: end }),
            ...(this.filterForm.get('user_uuid').value && {
                userUuid: this.filterForm.get('user_uuid').value
            }),
            ...(filterStatus.length > 0 && { status: filterStatus })
        };
        this.service
            .getAllTicketsForClient(this.service.clientUuid, filterData)
            .subscribe((data) => {
                this.service.ticketsStatistics.emit(data);
                this.service.newTicketBatch.emit(data);
            });
    }

    onSubmit(pagination: boolean, additionalFilters) {
        this.gameType = 'virtual_sport';

        this.filterForm
            .get('userUuid')
            .setValue(this.filterForm.get('userUuid').value.trim());

        this.service.selectedUserUuid.emit(
            this.filterForm.get('userUuid').value.trim()
        );

        if (this.filterComponentName == 'tickets') {
            this.loadTickets();
        }
    }

    changeDateInput() {
        this.filterForm.get('predefined_date').setValue('');
    }

    public search() {
        this.onSubmit(false, {});
    }

    getStartDate() {
        const start = formatDate(
            this.filterForm.get('start_date').value,
            'yyyy-MM-dd 00:00:00',
            'en'
        );
        return start;
    }
    getEndDate() {
        const end = formatDate(
            this.filterForm.get('end_date').value,
            'yyyy-MM-dd 23:59:59.999999',
            'en'
        );
        return end;
    }

    getStartDateSlots() {
        const start = formatDate(
            this.filterFormSlots.get('start_date').value,
            'yyyy-MM-dd 00:00:00',
            'en'
        );
        return start;
    }
    getEndDateSlots() {
        const end = formatDate(
            this.filterFormSlots.get('start_date').value,
            'yyyy-MM-dd 23:59:59.999999',
            'en'
        );

        return end;
    }

    delay(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    openModal() {
        this.modalShopOpen = true;
    }
    closeModalShow() {
        this.modalShopOpen = false;
    }
}

// userUuid
// created = payin_time
// cancel = now()
// pmachine_id
